<template>
    <div class="check-dt-voucher-form">
        <form @submit.prevent="search()">
            <div class="input-group-flex">
                <input ref="input"
                       class="form-control input-xl"
                       data-testid="voucher-search-input"
                       :placeholder="inputPlaceholder"
                       :value="ref"
                       :disabled="!isOnline"
                       @input="onInput" />
                <SquareBtn :color="btnColor"
                           :disabled="!isOnline || !ref"
                           data-testid="voucher-search-btn"
                           size="xl"
                           class="btn--inline-flex"
                           :loading="searching"
                           @click="search">
                    {{ l('SEARCH_MODAL.SEARCH') }}
                </SquareBtn>
                <SquareBtn :disabled="!isOnline || !ref"
                           size="xl"
                           data-testid="voucher-clear-btn"
                           class="btn--inline-flex btn-white"
                           :loading="searching"
                           @click="reset">
                    {{ l('CLEAR') }}
                </SquareBtn>
            </div>
        </form>

        <DtGiftVoucherStatus v-if="soldGiftVoucher"
                             class="mt-1"
                             :sold-gift-voucher="soldGiftVoucher"></DtGiftVoucherStatus>
        <div v-else-if="soldGiftVoucher === false"
             class="alert alert-danger mt-1">
            <i class="fa-solid fa-circle-xmark"></i> {{ l('SEARCH_MODAL.NO_RESULTS') }}
        </div>
    </div>
</template>

<script>
import DtGiftVoucherStatus from '@/epos/vue/modals/Search/DtGiftVoucherStatus';
import presentSoldGiftVoucherRefFilter from '@/filters/presentSoldGiftVoucherRef';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    name: 'CheckDtVoucherForm',

    components: { DtGiftVoucherStatus, SquareBtn },

    props: {
        btnColor: {
            type: String,
            default: 'primary',
        },
    },

    emits: [
        'selected',
    ],

    data() {
        return {
            searching: false,

            ref: '',

            /**
             * This will be false if a search happened and the voucher was not found.
             *
             * @type {SoldGiftVoucher|false|null}
             */
            soldGiftVoucher: null,
        };
    },

    computed: {
        ...mapState(['isOnline']),

        inputPlaceholder() {
            return container.langService.getText('SEARCH_MODAL.GIFT_VOUCHER_INPUT_PLACEHOLDER');
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },

    methods: {
        /**
         * @param {InputEvent} evt
         */
        onInput(evt) {
            // When the user changes the input clear the previous search results if there are any.
            this.soldGiftVoucher = null;
            this.$emit('selected', null);

            this.ref = presentSoldGiftVoucherRefFilter(evt.target.value);
        },

        search() {
            this.searching = true;

            container.soldGiftVoucherManager
                .findByRef(this.ref)
                .then((soldGiftVoucher) => {
                    this.soldGiftVoucher = soldGiftVoucher || false;

                    this.$emit('selected', this.soldGiftVoucher || null);
                })
                .finally(() => {
                    this.searching = false;
                });
        },

        reset() {
            this.ref = '';
            this.soldGiftVoucher = null;
            this.$refs.input.focus();
        },
    },
};
</script>
